import { render, staticRenderFns } from "./AddProduct.vue?vue&type=template&id=1fbb582b&scoped=true&"
import script from "./AddProduct.vue?vue&type=script&lang=js&"
export * from "./AddProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddProduct.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AddProduct.vue?vue&type=style&index=1&id=1fbb582b&lang=less&scoped=true&"
import style2 from "./AddProduct.vue?vue&type=style&index=2&id=1fbb582b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbb582b",
  null
  
)

export default component.exports